<div class="coupon">
  <div class="title-area">
    <div class="title" [class.title-center]="!cartView && !adminView">
      <span>
        {{
          coupon.receivedAmount - coupon.payedAmount
            | currency: 'EUR' : 'symbol' : '1.0-0'
        }}
      </span>
      <span> mehr </span>
    </div>
    @if (cartView || adminView) {
      <div class="delete-button">
        <button class="circle-medium" (click)="onDeleteCoupon()">
          <div class="circle-icon">
            <i class="fa-regular fa-trash-can"></i>
          </div>
        </button>
      </div>
    }
  </div>
  <div class="info-area">
    <div class="text-container">
      @if (adminView) {
        <div class="admin-toggle">
          <p-toggleswitch
            class="flex-r"
            [(ngModel)]="coupon.isActive"
            (onChange)="onCouponActiveStateChanged($event)">
          </p-toggleswitch>
          <div class="font-regular-title-large">
            {{ coupon.title }}
          </div>
        </div>
      } @else {
        <span class="title">{{ coupon.title }}</span>
      }
      <span class="font-regular-body-large">
        <strong>Zahle</strong>
        {{ coupon.payedAmount | currency: 'EUR' : 'symbol' : '1.0-0' }} und
        <strong>erhalte</strong>
        {{ coupon.receivedAmount | currency: 'EUR' : 'symbol' : '1.0-0' }}
        Wissensguthaben.
      </span>
      <span class="description">
        {{ coupon.description }}
      </span>
    </div>
    <div class="actions-container">
      <div class="flex-r gap-4">
        @if (!adminView) {
          <button
            class="circle-small"
            [disabled]="addedToShoppingCart"
            (click)="amountMinus()">
            <div class="circle-icon">
              <i class="fa-regular fa-minus fa-xs"></i>
            </div>
          </button>

          <div class="amount-divider flex-grow">
            <div class="divider-content">
              <span class="font-medium-title-regular">{{ amount }}</span>
              <div class="divider"></div>
            </div>
          </div>

          <button
            class="circle-small"
            [disabled]="addedToShoppingCart"
            (click)="amountPlus()">
            <div class="circle-icon">
              <i class="fa-regular fa-plus fa-xs"></i>
            </div>
          </button>
        }
      </div>
      @if (!cartView && !adminView) {
        <button
          class="inwi-text-button-medium-primary shopping-cart-button"
          (click)="addToShoppingCart(coupon)">
          <div class="button-content">
            @if (!addedToShoppingCart) {
              <div class="button-text">In den Einkaufswagen</div>
            } @else {
              <div class="button-text">Hinzugefügt</div>
            }
          </div>
        </button>
      }
      @if (adminView) {
        <button
          id="desktop-delete-button"
          class="inwi-icon-text-button-medium-secondary"
          (click)="onDeleteCoupon()">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-trash-can"></i>
            </div>
            <div class="button-text">Löschen</div>
          </div>
        </button>
      }
    </div>
  </div>
</div>
